"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CtaDropdown = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const SimpleDesktopDropdownMenu_1 = require("../menu/SimpleDesktopDropdownMenu");
const CtaButton_1 = require("./CtaButton");
const Styled = styled_components_1.default.div `
	height: 100%;
	.simple-menu-list {
		padding-top: 6px;
	}
`;
const CtaDropdown = ({ node, title, disabled, links }) => {
    if (disabled || !title || !(links === null || links === void 0 ? void 0 : links.length)) {
        return null;
    }
    const summaryNode = (react_1.default.createElement(CtaButton_1.CtaStyled, { className: "cta" },
        react_1.default.createElement("span", null, node || title)));
    return (react_1.default.createElement(Styled, null,
        react_1.default.createElement(SimpleDesktopDropdownMenu_1.SimpleDesktopDropdownMenu, { summaryNode: summaryNode, links: links, menuId: "cta-dropdown", rightAlign: true })));
};
exports.CtaDropdown = CtaDropdown;
//# sourceMappingURL=CtaDropdown.js.map